import * as THREE from 'three/webgpu';

export const CAM_MODES = ['CHASE', 'HOOD', 'ORBIT'];
export const CAM_LABELS = {
  CHASE: 'ПОГОНЯ',
  HOOD: 'КАПОТ',
  ORBIT: 'ОРБИТА'
};

export class CameraRig {
  constructor(camera) {
    this.camera = camera;
    this.modeIndex = 0;
    this.mode = CAM_MODES[this.modeIndex];

    this.currentPos = new THREE.Vector3(0, 40, -320);
    this.currentTarget = new THREE.Vector3(0, 36, -290);
    this.orbitAngle = 0;

    this.baseFov = 62;
    this.camera.fov = this.baseFov;
    this.camera.updateProjectionMatrix();
  }

  toggleMode() {
    this.modeIndex = (this.modeIndex + 1) % CAM_MODES.length;
    this.mode = CAM_MODES[this.modeIndex];
    return this.mode;
  }

  update(dt, jeep) {
    const cosYaw = Math.cos(jeep.yaw);
    const sinYaw = Math.sin(jeep.yaw);

    let targetPos = new THREE.Vector3();
    let lookTarget = new THREE.Vector3(jeep.pos.x, jeep.pos.y + 1.2, jeep.pos.z);

    if (this.mode === 'CHASE') {
      // Behind vehicle
      const dist = 7.4 + Math.min(2.5, jeep.speedKmh * 0.025);
      const height = 2.8;
      // Slight lead towards velocity vector
      const vLeadX = jeep.vel.x * 0.12;
      const vLeadZ = jeep.vel.z * 0.12;

      targetPos.set(
        jeep.pos.x - sinYaw * dist + vLeadX,
        jeep.pos.y + height,
        jeep.pos.z - cosYaw * dist + vLeadZ
      );
      lookTarget.set(
        jeep.pos.x + sinYaw * 4.0,
        jeep.pos.y + 1.1,
        jeep.pos.z + cosYaw * 4.0
      );

      const smoothFactor = 1.0 - Math.exp(-9.0 * dt);
      this.currentPos.lerp(targetPos, smoothFactor);
      this.currentTarget.lerp(lookTarget, smoothFactor);

    } else if (this.mode === 'HOOD') {
      // Mounted directly on hood / bonnet looking ahead
      const hoodX = 0.5 * sinYaw;
      const hoodZ = 0.5 * cosYaw;
      targetPos.set(
        jeep.pos.x + hoodX,
        jeep.pos.y + 1.05,
        jeep.pos.z + hoodZ
      );
      lookTarget.set(
        jeep.pos.x + sinYaw * 18.0,
        jeep.pos.y + 0.95,
        jeep.pos.z + cosYaw * 18.0
      );

      // Snappy response for first-person feel
      this.currentPos.copy(targetPos);
      this.currentTarget.lerp(lookTarget, 1.0 - Math.exp(-18.0 * dt));

    } else if (this.mode === 'ORBIT') {
      // Cinematic 360 rotation around car
      this.orbitAngle += dt * 0.6;
      const r = 9.5;
      targetPos.set(
        jeep.pos.x + Math.sin(this.orbitAngle) * r,
        jeep.pos.y + 3.4,
        jeep.pos.z + Math.cos(this.orbitAngle) * r
      );
      const smoothFactor = 1.0 - Math.exp(-6.0 * dt);
      this.currentPos.lerp(targetPos, smoothFactor);
      this.currentTarget.lerp(lookTarget, smoothFactor);
    }

    this.camera.position.copy(this.currentPos);
    this.camera.lookAt(this.currentTarget);

    // Dynamic FOV adjustment for high speed sensation
    const fovTarget = this.baseFov + Math.min(14, (jeep.speedKmh / 140) * 12) + (jeep.boosting ? 6 : 0);
    this.camera.fov += (fovTarget - this.camera.fov) * (1.0 - Math.exp(-6.0 * dt));
    this.camera.updateProjectionMatrix();
  }
}
